import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  padding: 60px;
  height: 100vh;
`;

export const Greeting = styled.div`
  font-size: 32px;
  color: #48484a;
`;

export const Name = styled.div`
  font-size: 48px;
  color: #1c1c1e;
  font-weight: 800;
`;
